import { heroStats } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[600px] w-full items-center overflow-hidden md:min-h-[680px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20flat%20illustration%20of%20a%20warm%20news%20media%20wall%20with%20floating%20cards%2C%20watermelon%20slices%20and%20chat%20bubbles%2C%20cream%20and%20coral%20red%20palette%20with%20leaf%20green%20accents%2C%20soft%20geometric%20shapes%2C%20editorial%20poster%20art%2C%20no%20text&width=1600&height=900&seq=17cc-hero-bg-01&orientation=landscape"
          alt="17.cc吃瓜攻略指南首屏背景：暖色调扁平插画风格的资讯卡片墙"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 py-[112px] md:px-8 md:py-[140px]">
        <div className="mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-10 lg:grid-cols-[1.15fr_0.85fr]">
          <div className="animate-rise">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-3.5 py-1.5 font-label text-xs tracking-wide text-white/90 backdrop-blur">
              <i className="ri-fire-line text-sm text-secondary-300" aria-hidden="true"></i>
              从入门到进阶 · 吃瓜技巧全整理
            </span>
            <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-white md:text-5xl lg:text-[3.4rem]">
              17.cc 吃瓜攻略指南
            </h1>
            <p className="mt-5 max-w-xl text-sm leading-relaxed text-white/85 md:text-lg">
              从「怎么吃瓜」到「吃得又快又准」，一份写给新手的 17.cc 吃瓜教程。跟着四步攻略跑通一次完整流程，热点不错过，细节不遗漏。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#steps"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-play-circle-line text-lg" aria-hidden="true"></i>
                立即查看攻略
              </a>
              <a
                href="#intro"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/30 bg-white/10 px-6 py-3.5 font-label text-sm font-medium text-white backdrop-blur transition-colors hover:bg-white/20"
              >
                <i className="ri-compass-3-line text-lg" aria-hidden="true"></i>
                了解吃瓜入门
              </a>
            </div>
          </div>

          <dl className="grid grid-cols-2 gap-3 md:gap-4">
            {heroStats.map((stat, index) => (
              <div
                key={stat.label}
                className="animate-rise rounded-lg border border-white/15 bg-white/10 p-4 backdrop-blur md:p-5"
                style={{ animationDelay: `${(index + 1) * 90}ms` }}
              >
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-white/15 text-white">
                  <i className={`${stat.icon} text-lg`} aria-hidden="true"></i>
                </span>
                <dd className="mt-3 font-heading text-2xl font-bold text-white md:text-3xl">
                  {stat.value}
                  <span className="ml-1 text-sm font-medium text-white/70">{stat.unit}</span>
                </dd>
                <dt className="mt-1 font-label text-xs text-white/75 md:text-sm">{stat.label}</dt>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}